import { isAppActive, onAppActiveChange } from "./app-active"
import { detectPlatform } from "./detect"

const IDLE_MS = 60_000

let kept: MediaStream | null = null
let idleTimer: ReturnType<typeof setTimeout> | null = null
let stopAppWatch: (() => void) | null = null

export function stopTracks(stream: MediaStream): void {
	for (const track of stream.getTracks()) {
		track.stop()
	}
}

function liveTrack(stream: MediaStream): MediaStreamTrack | null {
	const track = stream.getAudioTracks()[0]
	if (track?.readyState !== "live") return null
	return track
}

function canKeepMicStream(): boolean {
	return detectPlatform() === "telegram" && /Android/i.test(navigator.userAgent)
}

function clearGuards(): void {
	if (idleTimer !== null) {
		clearTimeout(idleTimer)
		idleTimer = null
	}
	stopAppWatch?.()
	stopAppWatch = null
}

export function releaseMicStream(): void {
	clearGuards()
	if (kept === null) return
	stopTracks(kept)
	kept = null
}

export function keepMicStream(stream: MediaStream): void {
	releaseMicStream()
	const track = liveTrack(stream)
	if (track === null || !canKeepMicStream() || !isAppActive()) {
		stopTracks(stream)
		return
	}
	track.enabled = false
	kept = stream
	idleTimer = setTimeout(releaseMicStream, IDLE_MS)
	stopAppWatch = onAppActiveChange((isActive) => {
		if (!isActive) releaseMicStream()
	})
}

export function takeMicStream(): MediaStream | null {
	const stream = kept
	if (stream === null) return null
	kept = null
	clearGuards()
	const track = liveTrack(stream)
	if (track === null) {
		stopTracks(stream)
		return null
	}
	track.enabled = true
	return stream
}
